import { api } from './api';

// A property's Loan Bids list: the lender contacts a broker means to pitch
// the loan to. The server reads each contact's lender, phones and email
// fresh, so the rows it answers with are the ones to show.
export const loanBidsApi = {
    list: (propertyId) => api.get('/properties/' + propertyId + '/loan-bids').then((res) => res.data),
    replace: (propertyId, vendorIds) =>
        api.put('/properties/' + propertyId + '/loan-bids', { vendor_ids: vendorIds }).then((res) => res.data),
};
